// @ts-nocheck
import { PrensaEngine } from '@xprog/prensa'
import { colors } from './assets/colors'
import typesystemObject from './indexes/type-system.json'

const { fontSizes, fontWeights, lineHeights } = typesystemObject

export const CBNTheme = PrensaEngine.createTheme('cbn', {
  colors: { ...colors },
  fonts: {
    primary: 'Roboto Slab',
    secondary: 'Fira Sans Condensed'
  },
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  radii: {
    unset: '0px',
    default: '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
})
